// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__D03_5","left":"StickyBox_left__2o_pF","right":"StickyBox_right__28Y2o"};